import React from 'react';
import { Button } from '../../../../../../wag-react/next-components/button';
import { EmailShareIcon } from '../../../../../../wag-react/next-components/icons';
export const EmailShareButton = ({
  shareUrl,
  subject
}) => <Button href={`mailto:?subject=${subject}&body=${shareUrl}`} data-sentry-element="Button" data-sentry-component="EmailShareButton" data-sentry-source-file="index.tsx">
    <EmailShareIcon data-sentry-element="EmailShareIcon" data-sentry-source-file="index.tsx" />
  </Button>;